import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getQueryData } from "src/helpers/helpers";
import useFetchAsync from "src/hooks/useFetchAsync";
import { deleteReq, useGet, usePatch, usePost } from "src/http-clients/clients";
import { getActiveStoreId } from "src/redux/selectors/app";

export const useCreateAppointment = () => {
  const activeStore = useSelector(getActiveStoreId);
  return usePost(`/users/stores/${activeStore}/appointments/create`);
};

export const useGetAppointments = ({
  length,
  page,
  search,
}: {
  length: number;
  page: number;
  search?: string;
}) => {
  const activeStore = useSelector(getActiveStoreId);
  const offset = page === 1 ? 0 : (page - 1) * length;
  const queryData = getQueryData({ length, offset, search });
  const data = useGet(
    `/users/stores/${activeStore}/appointments/list${queryData}`
  );
  return data;
};

export const useGetAppointmentData = (appointmentId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return useGet(
    appointmentId
      ? `/users/stores/${activeStore}/appointments/${appointmentId}`
      : null
  );
};

export const useUpdateAppointment = (appointmentId: number) => {
  const activeStore = useSelector(getActiveStoreId);
  return usePatch(`/users/stores/${activeStore}/appointments/${appointmentId}`);
};

export const useDeleteAppointment = () => {
  const activeStore = useSelector(getActiveStoreId);
  const deleteData = useCallback(
    (appointmentId: number) => {
      return deleteReq(
        `/users/stores/${activeStore}/appointments/${appointmentId}`
      );
    },
    [activeStore]
  );
  return useFetchAsync(deleteData);
};
